import { render, staticRenderFns } from "./SolutionsDetails.vue?vue&type=template&id=3a268be8&scoped=true&"
import script from "./SolutionsDetails.vue?vue&type=script&lang=js&"
export * from "./SolutionsDetails.vue?vue&type=script&lang=js&"
import style0 from "./SolutionsDetails.vue?vue&type=style&index=0&id=3a268be8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a268be8",
  null
  
)

export default component.exports